import { makeCountryQuiz } from './_country-quiz-factory';

/**
 * Six regional country quizzes — one per inhabited continent. Each
 * filters to UN members in that continent (factory-baked) and frames
 * the globe on the region at mount.
 *
 * Camera framing is read from `CONTINENT_CAMERAS` in `framework/filterSlug.ts`
 * (single source of truth shared with filtered practice modes). Quizzes
 * can override per-spec via `cameraView` if a quiz ever wants different
 * framing than the practice-mode filter for the same continent — none
 * currently do.
 *
 * Adding a new region quiz: one entry here, register in registry.ts.
 * Sidebar auto-renders.
 */

export const europeCountryQuiz = makeCountryQuiz({
  region: 'europe',
  continent: 'Europe',
  displayName: 'Europe Countries Quiz',
  shortName: 'Europe',
});

export const africaCountryQuiz = makeCountryQuiz({
  region: 'africa',
  continent: 'Africa',
  displayName: 'Africa Countries Quiz',
  shortName: 'Africa',
  // Force-include three countries that the continents.json dataset
  // tags differently than expected:
  //   EH  Western Sahara — not a UN member but unambiguously African
  //                         and distinct on the map. Quiz feels
  //                         incomplete without it.
  //   MU  Mauritius      — UN member; Natural Earth tags island
  //                         nations as `continent: "Seven seas (open
  //                         ocean)"` so they fall out of the Africa
  //                         continent filter despite their region
  //                         being correctly "Africa".
  //   SC  Seychelles     — same dataset quirk as Mauritius.
  additionalIsos: ['EH', 'MU', 'SC'],
});

export const northAmericaCountryQuiz = makeCountryQuiz({
  region: 'north-america',
  continent: 'North America',
  displayName: 'North America Countries Quiz',
  shortName: 'North America',
});

export const southAmericaCountryQuiz = makeCountryQuiz({
  region: 'south-america',
  continent: 'South America',
  displayName: 'South America Countries Quiz',
  shortName: 'South America',
});

export const asiaCountryQuiz = makeCountryQuiz({
  region: 'asia',
  continent: 'Asia',
  displayName: 'Asia Countries Quiz',
  shortName: 'Asia',
  // Maldives is a UN member but Natural Earth tags it as
  // `continent: "Seven seas (open ocean)"`, so it falls out of the
  // Asia continent filter despite its region being correctly "Asia".
  // Same dataset quirk as Mauritius / Seychelles on the Africa quiz.
  additionalIsos: ['MV'],
});

export const oceaniaCountryQuiz = makeCountryQuiz({
  region: 'oceania',
  continent: 'Oceania',
  displayName: 'Oceania Countries Quiz',
  shortName: 'Oceania',
});

/** Convenient flat list — registry imports this and spreads it. */
export const ALL_COUNTRY_QUIZZES = [
  europeCountryQuiz,
  africaCountryQuiz,
  northAmericaCountryQuiz,
  southAmericaCountryQuiz,
  asiaCountryQuiz,
  oceaniaCountryQuiz,
];
